import { Typography, styled, css } from '@mui/material';

export const StyledTypography = styled(Typography)(
  ({ theme }) => css`
    margin-top: ${theme.spacing(3)};
    font-size: 0.87rem;
  `,
) as typeof Typography;
